const styles = (theme) => ({
	root: {
		position: "relative",
	},
});

export default styles;
